'use client';

import Loading from '@/components/ui/Loading';
import { LoadingProvider } from '@/contexts/loading';
import { OtpProvider } from '@/contexts/otp';
import { RegisterInfoProvider } from '@/contexts/register';
import { ThemeContextProvider } from '@/contexts/themeContext';
import { SessionProvider } from "next-auth/react";
import React from 'react';

interface ProvidersProps {
  children: React.ReactNode;
}

const Providers = ({ children }: ProvidersProps) => {
  return (
    <ThemeContextProvider>
      <SessionProvider>
        <OtpProvider>
          <LoadingProvider>
            <RegisterInfoProvider>
              {children}
            </RegisterInfoProvider>
            <Loading />
          </LoadingProvider>
        </OtpProvider>
      </SessionProvider>
    </ThemeContextProvider>
  )
}

export default Providers;